export default __webpack_public_path__ + "static/media/fee.2f7ead3c.svg";